import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { setApiTokens } from "../actions/userActions";

export function AuthenticatedProvider({ api, children, onLoadAuth0 }) {
    const auth0 = useAuth0();

    useEffect(function() {
        if (!api || !api.auth0) {
            onLoadAuth0(auth0);
        }
    }, [api, auth0, onLoadAuth0]);

    if (!api || !api.auth0) {
        return null;
    }

    return <React.Fragment>{children}</React.Fragment>;
}

function mapStateToProps(state, ownProps) {
    return { api: state.api };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onLoadAuth0(auth0) {
            dispatch(setApiTokens(auth0));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedProvider);



// WEBPACK FOOTER //
// ./app/components/AuthenticatedProvider.jsx